const INV_STATUS = {
    PENDING: "انتظار",
    APPROVED: "مقبول",
    REJECTED: "مرفوض",
    DELETED: "محذوف"
}

export default INV_STATUS;